import React from 'react';
import PropTypes from 'prop-types';
import css from "./Label.module.scss";
import {colors} from "../../utils/colors.js";

const iconStyles = {
  marginRight: 8,
};

const iconStylesRight = {
  marginLeft: 8,
  order: 1,
};

const Label = ({
  variant = '',
  color = '#333',
  backgroundColor = '#eee',
  className,
  count,
  icon,
  iconPosition = 'left',
  iconColor,
  iconOnClick,
  badgeColor = 'white',
  badgeBackgroundColor,
  children,
  onClick,
  style = {},
}) => {
  if (variant === 'success') {
    color = colors.success
    backgroundColor = colors.success20
  } else if (variant === 'warning') {
    color = colors.warning
    backgroundColor = colors.warning10
  } else if (variant === 'danger') {
    color = colors.danger
    backgroundColor = colors.danger20
  } else if (variant === 'disabled') {
    color = colors.grey
    backgroundColor = colors.disabled
  }

  return (
    <span
      className={`${css.label} ${className}`}
      onClick={onClick}
      style={{
        cursor: onClick ? 'pointer' : null,
        color: color,
        backgroundColor: backgroundColor,
        ...style,
      }}
    >
      {iconPosition === 'left' && (
        <LabelIcon 
          icon={icon} 
          color={iconColor || color}
          onClick={iconOnClick}
          position="left"
        />
      )}
      <span>{children}</span>
      {typeof count === 'number' &&
        <span
          className={css.badge}
          style={{
            color: badgeColor || color,
            backgroundColor: badgeBackgroundColor || backgroundColor,
            fontSize: 11,
          }}
        >
          {count}
        </span>
      }
      {iconPosition === 'right' && (
        <LabelIcon 
          icon={icon} 
          color={iconColor || color}
          onClick={iconOnClick}
          position="right"
        />
      )}
    </span>
  );
};

const LabelIcon = ({icon, color, onClick, position}) => {
  if (!icon) return null;

  const IconComponent = icon;
  const iconStyle = position === 'right' ? iconStylesRight : iconStyles;
  
  return (
    <span
      className={css.labelIcon}
      style={{
        ...iconStyle,
        cursor: onClick ? 'pointer' : 'default',
      }}
      onClick={(e) => {
        if (onClick) {
          e.stopPropagation();
          onClick(e);
        }
      }}
    >
      <IconComponent color={color}/>
    </span>
  );
};

Label.propTypes = {
  variant: PropTypes.oneOf([
    'success',
    'warning',
    'danger',
    'disabled',
  ]),
  children: PropTypes.node.isRequired,
  color: PropTypes.string,
  backgroundColor: PropTypes.string,
  count: PropTypes.number,
  icon: PropTypes.func,
  iconPosition: PropTypes.oneOf(['left', 'right']),
  iconColor: PropTypes.string,
  iconOnClick: PropTypes.func,
  badgeColor: PropTypes.string,
  badgeBackgroundColor: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func,
};

export default Label;
